import React from 'react';
import { motion } from 'framer-motion';
import { useNavigate } from 'react-router-dom';

const Hero = () => {
  const navigate = useNavigate();
  return (
    <section id="about" className="pt-32 md:pt-36 pb-20 md:pb-28 bg-white">
      <div className="max-w-7xl mx-auto px-6 md:px-10 grid md:grid-cols-2 gap-10 lg:gap-16 items-center">
        <div className="order-2 md:order-1">
          <motion.h1
            initial={{ opacity: 0, y: 40 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.9, ease: [0.22, 1, 0.36, 1] }}
            className="font-display text-[56px] md:text-[80px] lg:text-[96px] leading-[0.98] tracking-tight font-medium text-neutral-900"
          >
            A-Levels, GCSEs?<br />Sorted!
          </motion.h1>

          <motion.p
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.7, delay: 0.3 }}
            className="mt-6 text-[16px] md:text-[18px] leading-[1.6] text-neutral-700 max-w-md"
          >
            Helping students understand science, not just memorise it.
          </motion.p>

          <motion.button
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 0.55 }}
            whileHover={{ scale: 1.03 }}
            whileTap={{ scale: 0.97 }}
            onClick={() => navigate('/tuition#the-method')}
            className="pill-btn mt-10 bg-neutral-900 text-white px-7 py-3.5 text-[14px] font-medium"
          >
            Explore More
          </motion.button>
        </div>

        <motion.div
          initial={{ opacity: 0, scale: 0.95, y: 30 }}
          animate={{ opacity: 1, scale: 1, y: 0 }}
          transition={{ duration: 1.0, ease: [0.22, 1, 0.36, 1], delay: 0.15 }}
          className="order-1 md:order-2"
        >
          <div className="hero-image-rounded aspect-[4/5] md:aspect-[5/6] w-full max-w-[560px] mx-auto rounded-3xl overflow-hidden">
            <img
              src="/images/hamza-suit.png"
              alt="Hamza Munum — A-Level Biology & Chemistry tutor"
              loading="eager"
              decoding="async"
              className="w-full h-full object-cover"
            />
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default Hero;
